import { updateUserCategory } from "../../../actions/siteadmin/updateUserCategory";
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;

    const submittedData = {
        categories: values.categories,
        categoryId: values.categoryId,
        profileId: values.profileId
    }

    await dispatch(updateUserCategory(submittedData))
}
export default submit